import { lazy } from "react";
import { REFILL } from "pages/routes/route.constant";
const refill = lazy(() => import("pages/Refill"));

export default {
  path: REFILL,
  element: refill,
};
